<template>
  <div class="c-textarea-box__wrapper" v-bind:class="showBefore">
    <div class="c-textarea-box">
      <div class="c-textarea-box__question">
        <h2 class="c-textarea-box__title">{{ question.label }}</h2>
        <div class="c-rap-rte" v-if="question.helpText" v-html="question.helpText"></div>
      </div>

      <div class="c-textarea-box__answer">
        <div class="c-form-textarea">
          <label
            class="c-form-textarea__label" 
            v-bind:class="{ 'c-form-textarea__label--required': question.mandatory }"
            v-bind:for="question.id">
            {{ question.fieldLabel }}
          </label>
          <textarea
            class="c-form-textarea__control"
            cols="50"
            rows="10"
            maxlength="500"
            v-bind:id="question.id"
            v-bind:name="question.id"
            v-bind:aria-label="question.id"
            v-bind:class="{ 'c-form-textarea__control--is-invalid': isInvalid }"
            v-model="question.answer"
            v-on:change="onChange"
            v-on:focus="onFocus">
          </textarea>
          <span
            class="c-form-input__validation-message"
            v-bind:aria-label=question.validation
            v-if="isInvalid">
            {{ question.validation }}
          </span>
        </div>
      </div>

      <div class="c-rap-rte" v-if="question.text" v-html="question.text"></div>

      <div class="c-textarea-box__actions" v-if="!isSubmitted">
        <button
          type="button" 
          class="c-button c-button--brand c-button--text-center" 
          v-on:click="emitInput">
          {{ question.buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      required: true,
      type: Number,
    },
    question: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      isSubmitted: false,
    }
  },
  destroyed() {
    this.isSubmitted = false;
    this.question.answer = '';
  },
  computed: {
    isInvalid() {
      return this.question.mandatory === true && (this.question.answer === '' || this.question.answer === undefined);
    },
    showBefore() {
      return this.index > 0 ? 'c-radio-options-box__wrapper--before' : '';
    }
  },
  watch: {
    'question.answer'(newVal) {
      if (newVal === '') {
        this.isSubmitted = false;
      }
    }
  },
  methods: {
    onFocus() {
      if (this.question.answer === '') {
        delete this.question.answer;
      }
    },
    onChange() {
      this.emitInput();
    },
    emitInput() {
      if (this.isInvalid === false) {
        this.isSubmitted = true;
        this.$emit('input', this.question.answer, this.index, this.question.questionId, this.question.nextId, this.question.final, this.question.upload);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/TextareaBox.vue